document.addEventListener("DOMContentLoaded", function () {
    const riveBlocks = document.querySelectorAll('.bds-riveblock__asset');

    if (riveBlocks.length > 0) {

        for (let i = 0; i < riveBlocks.length; i++) {
            const block = riveBlocks[i];
            const canvas = block.querySelector('canvas');
            const src = block.getAttribute('data-src');
            const autoplay = block.getAttribute('data-autoplay');

            const layout = new rive.Layout({
                fit: rive.Fit.Contain,
                alignment: rive.Alignment.Center,
                layoutScaleFactor: 2,
            });

            
            const r = new rive.Rive({
                src: src,
                canvas: canvas,
                autoplay: autoplay === 'true',
                loop: autoplay === 'true',
                layout: layout,
                stateMachines: ['State Machine 1'],
                onLoad: () => {
                    computeSize();
                },
            });

            function computeSize() {
                r.resizeDrawingSurfaceToCanvas();
            }

            // TODO: debounce resize
            window.addEventListener('resize', computeSize);

            window.matchMedia(`(resolution: ${window.devicePixelRatio}dppx)`).addEventListener('change', computeSize);
        }
    }

});